/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Phone_Is_Call_History_EnabledInputs */

const en_forms_templates_settings_phone_is_call_history_enabled = /** @type {(inputs: Forms_Templates_Settings_Phone_Is_Call_History_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const de_forms_templates_settings_phone_is_call_history_enabled = /** @type {(inputs: Forms_Templates_Settings_Phone_Is_Call_History_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Forms_Templates_Settings_Phone_Is_Call_History_EnabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_phone_is_call_history_enabled = /** @type {((inputs?: Forms_Templates_Settings_Phone_Is_Call_History_EnabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Phone_Is_Call_History_EnabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_phone_is_call_history_enabled(inputs)
	return de_forms_templates_settings_phone_is_call_history_enabled(inputs)
});